import { bus, axios, apiURL } from '../main'

export default {
    state: { // state des Moduls wird direkt auf die variable state.modulX gemappt
        navigation: [
            /* { name: 'Home', route: 'home', group: 'left', icon: 'home', children: [] }, */
        ],
        routes: [],
        home: [
            /* { name: 'Analysen', route: 'analysen', group: 'left', image: 'analysen', refs: [] }, */
        ],
    },
    actions: { // call from outside as action: this.$store.dispatch('LOAD_abcd')
        loadNavigation: async function ({ commit }) {
            try {
                var navigation = await axios.get(apiURL + 'public.cfc?method=getNavigation')
                await commit('setNavigation', navigation.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading navigation ... ' + JSON.stringify(e.message))
                commit('setNavigation', [])
            }
        },
        loadHome: async function ({ commit }) {
            try {
                var home = await axios.get(apiURL + 'public.cfc?method=getHome')
                await commit('setHome', home.data)
            }
            catch (e) {
                bus.$emit('error', 'Error loading home ... ' + JSON.stringify(e.message))
                commit('setHome', [])
            }
        },
    },
    mutations: { //call with this.$store.commit('setExampleFn',{'a':'b'})
        setNavigation: async function (state, navigation) {
            state.navigation = navigation
            // vorhandene Routen als Liste für die Berechtigung hinterlegen
            state.routes = []
            var route = ''
            for (var nav of navigation) {
                route = nav.route.split('/')[0]
                if (route !== '' && !state.routes.includes(route))
                    state.routes.push(route)
                for (var subnav of nav.children) {
                    route = subnav.route.split('/')[0]
                    if (route !== '' && !state.routes.includes(route))
                        state.routes.push(route)
                }
            }
            bus.$emit('navigationLoaded')
        },
        setHome: async function (state, home) {
            state.home = home
            bus.$emit('homenLoaded')
        }
    }
}